import React from "react"
import { Button, Col, Modal } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import { useQuery } from "react-query"
import useListingPagination from "../../common/hooks/UseListingPagination"
import ListingWrapper from "../../common/listing/ListingWrapper"
import { ProductStockQuantitiesModalProps } from "../../common/types/inventory"
import IntlProps from "../../state/helpers/IntlProps"
import { InTransitService } from "../../state/inventory/intransit/service/intransitservice"
import { ReservationService } from "../../state/inventory/reservations/service/reservationservice"
import { INVENTORY_IN_TRANSIT, INVENTORY_RESERVATION, PRODUCT_STOCK_QUANTITIES_LISTING_MESSAGES } from "../../utils/inventory"
import { getRowsData } from "../../utils/inventory/productQuantitiesListingHelper"
import { PRODUCT_STOCK_QUANTITIES_HEADERS } from "../../utils/inventory/utils"

const ProductStockQuantitiesModal = (props: ProductStockQuantitiesModalProps & IntlProps) => {

    const getFilters = () => {
        const filters = {
            productId: props.productId,
            inventoryLocationIdKeyword: props.locationId,
        }
        switch(props.selectedModal) {
        case INVENTORY_RESERVATION:
            filters["calculatedReserved"] = ">;0"
            break
        case INVENTORY_IN_TRANSIT:
            filters["calculatedInTransit"] = ">;0"
            break
        }
        return filters
    }

    const {
        paginatedSearch,
        updateTotalItemsCount,
        pagination,
    } = useListingPagination({
        keywords: "*",
        sortByField: "createdAt",
        sortAsc: false,
        pageSize: 25,
        activePage: 1,
        filters: getFilters(),
    })

    const { error, isLoading, data: responseData } = useQuery(["stock-product-quantities-modal", paginatedSearch], () => {
        switch(props.selectedModal) {
        case INVENTORY_RESERVATION:
            return ReservationService.findReservationsBySearchPayload({ ...paginatedSearch, filters: getFilters() })
        case INVENTORY_IN_TRANSIT: 
            return InTransitService.findInTransitBySearchPayload({ ...paginatedSearch, filters: getFilters() })
        }
    }, {
        onSuccess: (data) => {
            if (data) {
                updateTotalItemsCount(data.metadata.totalItemsCount)
            }
        }
    })

    const items = responseData?.data || []
    const totalItemsCount = responseData?.metadata?.totalItemsCount || 0

    const headers = {
        data: PRODUCT_STOCK_QUANTITIES_HEADERS.map((e) => <FormattedMessage  {...e} key={e.id} />),
        classNames: []
    }
        
    const rows = items.map(item => {
        return {
            rowId: item.id,
            data: getRowsData(item),
        }
    })

    const modalHeader = () => {
        if(props.selectedModal === INVENTORY_RESERVATION) {
            return props.intl.formatMessage(PRODUCT_STOCK_QUANTITIES_LISTING_MESSAGES.inventoryReservedHeader)
        } else if (props.selectedModal === INVENTORY_IN_TRANSIT) {
            return props.intl.formatMessage(PRODUCT_STOCK_QUANTITIES_LISTING_MESSAGES.inventoryInTransitHeader)
        }
    }
        
    const standardList = {
        className: "row pt-2",
        headers: headers,
        rows: rows,
        smallLine: true,
        pageSize: paginatedSearch.pageSize,
        totalItemsCount: totalItemsCount,
        showSelectionSize: false,
    }

    const search = <></>

    return (
        <Modal 
            show={true}
            size={"lg"}
            backdrop="static"
            onHide={props.onCloseCallback}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5>
                        {modalHeader()}
                    </h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Col>
                    <ListingWrapper
                        isLoading={isLoading}
                        error={error as Error}
                        search={search}
                        showHeaders={true}
                        standardListProps={standardList}
                        footer={
                            <Col className="px-2">
                                {pagination()}
                            </Col>
                        }
                    />
                </Col>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={props.onCloseCallback}
                    variant="secondary">
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )

}

export default injectIntl(ProductStockQuantitiesModal)


// WEBPACK FOOTER //
// ./src/inventory/modals/ProductStockQuantitiesModal.tsx